export default class reportesController{
	constructor(
		$scope,
		$routeParams,
		method,
		reportesService
	){

		this.scope     = $scope;
		this.scope.aux = {};

		switch (method) {
			case 'main':
				this.list(reportesService);
			break;
		}
	}

	list(reportesService){

		this.scope.get_reporte = this.get_reporte.bind(this, reportesService);

		reportesService.getAll()
			.then((resp, err) => {
				let aux = resp.data

				let data_agrupada = {};

				for (var key in aux) {
					let elemento = aux[key];
					if (data_agrupada[elemento.collection] === undefined) {
						data_agrupada[elemento.collection] = [];
						data_agrupada[elemento.collection].push(elemento);
					}else{
						data_agrupada[elemento.collection].push(elemento);
					}
				}

				this.scope.aux.reportes = data_agrupada;
			});
	}

	get_reporte(reportesService, codigo){

		let filter = {
			codigo: codigo
		}

		reportesService.getByCode(filter);
			// .then((resp, er) => {
			// 	console.log(resp);
			// });
	}

}



// WEBPACK FOOTER //
// ./app/js/controllers/reportes/reportesController.js